import React from 'react';
import parse from 'html-react-parser';
import { Box, Grid, Typography } from '@material-ui/core';
import { css } from 'styled-components/macro';
import {
  AccordionProps,
  Accordion,
  ContentProps,
} from 'app/components/Accordion';
import {
  ExploringList,
  FaqList,
  TechnicalList,
  AidaPackagesList,
} from 'app/modules/faq-module/content';

const typographyCss = css`
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
`;

const faqCss = css`
  font-size: 36px;
  font-weight: 700;
  line-height: 44px;
`;

export const FaqModuleLayout = () => {
  function RenderList(props: ContentProps[], type: string) {
    return props.map((item: AccordionProps, index: number) => {
      return (
        <Accordion
          label={item.label}
          content={parse(item.content as string)}
          id={`question-${type}-${index}`}
          key={item.label}
        />
      );
    });
  }

  return (
    <Box marginTop="50px">
      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h2" css={faqCss}>
          FAQ
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        {RenderList(FaqList, 'faq')}
      </Grid>
      <Box marginTop="50px" />

      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h2" css={typographyCss}>
          Exploring the data
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        {RenderList(ExploringList, 'explore')}
      </Grid>
      <Box marginTop="50px" />

      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h2" css={typographyCss}>
          Technical questions
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        {RenderList(TechnicalList, 'technical')}
      </Grid>
      <Box height="50px" />

      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h2" css={typographyCss}>
          AIDA pricing and packages
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        {RenderList(AidaPackagesList, 'pricing')}
      </Grid>
      <Box height="50px" />
    </Box>
  );
};
